import "./index.less";
import React from "react";

interface OrderSortTipContentProps {
    title?: string;

    rule?: string;

    eg?: string;

    for?: string;
}

const OrderSortTipContent: React.FC<OrderSortTipContentProps> = React.memo(function (props) {
    const { title, rule, eg, for: forSth } = props;

    return (
        <div className="order-sort-tip-content-container">
            {title ? <div className="title">{title}</div> : null}

            {rule ? (
                <div className="rule">
                    <p className="sub-title">规则</p>
                    <p>{rule}</p>
                </div>
            ) : null}

            {eg ? (
                <div className="eg">
                    <p className="sub-title">示例</p>
                    <p className="pre-line">{eg}</p>
                </div>
            ) : null}

            {forSth ? (
                <div className="for">
                    <p className="sub-title">适用场景</p>
                    <p>{forSth}</p>
                </div>
            ) : null}
        </div>
    );
});

export default OrderSortTipContent;
